module.exports = __webpack_public_path__ + "media/images/front/pc/features/search/doctors/related_hospital-ee1ddf5e65674ce694728b1587ce98ff.png";